export default __webpack_public_path__ + "static/media/myPhoto.52e5759d.jpeg";